import { render, staticRenderFns } from "./Column2Chart.vue?vue&type=template&id=2210ddd5&scoped=true"
import script from "./Column2Chart.vue?vue&type=script&lang=js"
export * from "./Column2Chart.vue?vue&type=script&lang=js"
import style0 from "./Column2Chart.vue?vue&type=style&index=0&id=2210ddd5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210ddd5",
  null
  
)

export default component.exports